export default __webpack_public_path__ + "static/media/Logo.ce5b7d82.png";